import { useLocation } from 'react-router-dom';

import { AppRoutes } from 'constants/routes-paths.constants';
import { CustomersForm } from 'page-components/customers/CustomersForm';
import { PageLayout } from 'page-components/page-layout/PageLayout';

export const Customer = () => {
  const { pathname } = useLocation();

  const editTitle = pathname === AppRoutes.customerCreate ? 'create_customer' : 'edit_customer';
  const titleText = pathname.includes('view') ? 'view_customer' : editTitle;

  return (
    <PageLayout title={titleText} wrapperClassName='flex flex-col gap-4'>
      <CustomersForm />
    </PageLayout>
  );
};
